import script from "./DataTableBulkOperations.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataTableBulkOperations.vue?vue&type=script&setup=true&lang=ts"

import "./DataTableBulkOperations.vue?vue&type=style&index=0&id=ca07af06&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca07af06"]])

export default __exports__